import { FC } from "react";
import {
  Control,
  Controller,
  FieldValues,
  UseFormSetValue,
} from "react-hook-form";

import { CatchARideAvailabilityItem } from "./catch-a-ride-availability-item";

interface ICatchARideAvailabilityRowProps {
  fieldName: string;
  index: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  parentControl: Control<FieldValues, any>;
  parentSetValue: UseFormSetValue<FieldValues>;
  removeHandler: (index: number) => void;
  disabledEdit?: boolean;
  disabledRemove?: boolean;
  onEditStart?: () => void;
  onEditEnd?: () => void;
}

export const CatchARideAvailabilityRow: FC<ICatchARideAvailabilityRowProps> = ({
  fieldName,
  index,
  parentControl,
  parentSetValue,
  removeHandler,
  disabledEdit,
  disabledRemove,
  onEditStart,
  onEditEnd,
}) => {
  return (
    <Controller
      name={`${fieldName}[${index}]`}
      control={parentControl}
      render={({ field: { value: itemValue } }) => (
        <CatchARideAvailabilityItem
          fieldName={`${fieldName}[${index}]`}
          index={index}
          value={itemValue}
          removeHandler={removeHandler}
          setValueOuter={parentSetValue}
          disabledEdit={disabledEdit}
          disabledRemove={disabledRemove}
          onEditStart={onEditStart}
          onEditEnd={onEditEnd}
        />
      )}
    />
  );
};
